import { Languages } from 'common/types';

import finnishFlag from 'common/assets/finland-flag-round-icon-64.png';
import englishFlag from 'common/assets/united-kingdom-flag-round-icon-64.png';
import slovakiaFlag from 'common/assets/slovakia-flag-round-icon-64.png';
import swedishFlag from 'common/assets/sweden-flag-round-icon-64.png';
import germanyFlag from 'common/assets/germany-flag-round-icon-64.png';
import russianFlag from 'common/assets/russia-flag-round-icon-64.png';
import netherlandsFlag from 'common/assets/netherlands-flag-round-icon-64.png';
import hungarianFlag from 'common/assets/hungary-flag-round-icon-64.png';
import norwegianFlag from 'common/assets/norway-flag-round-icon-64.png';
import frenchFlag from 'common/assets/france-flag-round-icon-64.png';
import spanishFlag from 'common/assets/spain-flag-round-icon-64.png';
import italianFlag from 'common/assets/italy-flag-round-icon-64.png';
import czechFlag from 'common/assets/czech-republic-flag-round-icon-64.png';
import lithuanianFlag from 'common/assets/lithuania-flag-round-icon-64.png';
import danishFlag from 'common/assets/denmark-flag-round-icon-64.png';
import estonianFlag from 'common/assets/estonia-flag-round-icon-64.png';
import sloveniaFlag from 'common/assets/slovenia-flag-round-icon-64.png';

export const flags = {
	fi: finnishFlag,
	en: englishFlag,
	sk: slovakiaFlag,
	sv: swedishFlag,
	de: germanyFlag,
	ru: russianFlag,
	nl: netherlandsFlag,
	hu: hungarianFlag,
	no: norwegianFlag,
	fr: frenchFlag,
	es: spanishFlag,
	it: italianFlag,
	cs: czechFlag,
	da: danishFlag,
	et: estonianFlag,
	lt: lithuanianFlag,
	sl: sloveniaFlag,
};

export const getLanguageFlag = (lang: Languages) => flags[lang];
